export default __webpack_public_path__ + "static/media/autoloanallocation.67887ef0.svg";